<script setup lang="ts">
const { countrySetting, updateCountrySetting } = useCountrySetting()
const { countryOptions } = useFrontendConfiguration()

function getOptionLabelByValue(value: string) {
  return countryOptions.value.find(l => l.value === value)!.label
}

function switchCountry(newCountry: CountryType) {
  updateCountrySetting(newCountry)
}
</script>

<template>
  <Select
    :model-value="countrySetting ?? 'DE'"
    :options="countryOptions"
    option-value="value"
    option-label="label"
    @update:model-value="switchCountry"
  >
    <template #value="slotProps">
      <div
        class="flex items-center"
      >
        <span :class="['my-1', 'mr-2', 'fi', 'min-w-5', 'max-w-5', `fi-${slotProps.value.toLowerCase()}`]" />
        <div>{{ getOptionLabelByValue(slotProps.value) }}</div>
      </div>
    </template>
    <template #option="slotProps">
      <div class="flex items-center">
        <span :class="['my-1', 'mr-2', 'fi', 'min-w-5', 'max-w-5', `fi-${slotProps.option.value.toLowerCase()}`]" />
        <div>{{ slotProps.option.label }}</div>
      </div>
    </template>
  </Select>
</template>
